import styled from "styled-components";
import { useState } from "react";
import { RAButtonPrimary, RATextInput, RATypography } from "@/components/customs";
import { Row, Col, Modal, Divider } from "antd";
import { IconCloseSvg } from "@/components/svgs";
import { useDispatch } from "react-redux";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE, SUITE_REQUEST_LEVEL } from "@/config/constants";
import { fetchRequestSuiteAccess } from "@/stores/slices/authSlice";

const initFormRequest = {
	company: "",
	tail_number: "",
	note: "",
};

export function ModalRequestJetOneSuites({ visible = false, onClose, onRequestSuccess }) {
	const dispatch = useDispatch();
	const [formRequest, setFormRequest] = useState(initFormRequest);

	const onAddContact = async () => {
		const payload = {
			level: SUITE_REQUEST_LEVEL.EDIT,
			request_suite_request_metadata: {
				company_name: formRequest.company,
				aircraft_tail_number: formRequest.tail_number,
				note: formRequest.note,
			},
		};
		let response = await dispatch(fetchRequestSuiteAccess(payload));
		if (response && response.payload) {
			onRequestSuccess?.(formRequest);
			setFormRequest(initFormRequest);
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Request access to an existing account failed.",
			});
		}
	};

	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => {
				onClose(false);
				setFormRequest(initFormRequest);
			}}
			footer={null}
			wrapClassName="auth-wrapper"
			width="auto"
			// style={{ padding: "clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px)" }}
			// bodyStyle={{ padding: "40px 40px" }}
		>
			<Container>
				<Row>
					<Col span={24}>
						<WrapperContent>
							<RATypography variant="h3">Request Access To An Existing Account</RATypography>
						</WrapperContent>
						<RATypography variant="body3" top="12px" color="#595959">
							{
								"To gain access, please specify the account you wish to use. If you're interested in becoming a Jet 1 Suites tenant, kindly reach out to us through the contact us page for further assistance."
							}
						</RATypography>
					</Col>
				</Row>
				<Divider />
				<Row gutter={[20, 20]}>
					<Col span={24}>
						<RATextInput
							data-testid="RequestAccess_companyInput"
							title="Company (optional)"
							placeholder="Enter company name"
							value={formRequest.company}
							onChange={(val) =>
								setFormRequest({
									...formRequest,
									company: val,
								})
							}
						/>
					</Col>
					<Col span={24}>
						<RATextInput
							data-testid="RequestAccess_tailNumberInput"
							title="Aircraft Tail Number (optional)"
							placeholder="Enter aircraft tail number"
							value={formRequest.tail_number}
							onChange={(val) =>
								setFormRequest({
									...formRequest,
									tail_number: val,
								})
							}
						/>
					</Col>
					<Col span={24}>
						<RATextInput
							data-testid="RequestAccess_notesInput"
							title="Additional Notes"
							placeholder="Enter additional notes"
							value={formRequest.note}
							type="textarea"
							onChange={(val) =>
								setFormRequest({
									...formRequest,
									note: val,
								})
							}
						/>
					</Col>
				</Row>
				<Row justify="center" align="middle" style={{ marginTop: "40px" }}>
					<RAButtonPrimary
						data-testid="RequestAccess_submitBtn"
						title="SUBMIT"
						onClick={() => onAddContact()}
					/>
				</Row>
			</Container>
		</Modal>
	);
}

const Container = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 720px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
